import {
  Component
} from 'react';
import fetchCandidateResume from '../../../lib/Candidate/fetchCandidateResume.async';
import Core from "../../../lib/Core";
import {
  getPersonName
} from '../../../lib/Object.lib';
import {
  joinKeyName,
  Str
} from '../../../lib/String.lib';
import Box from '../../Layout/Wrappers/Box';
import Button from '../../Layout/Wrappers/Button';
import IconButton from '../../Layout/Wrappers/IconButton';
import {
  getControllerCandidateEdit
} from '../Edit/CandidateEdit';

export default class ResumeLinks extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      sovrenData: []
    }
  }
  render() {
    const { resumes, onError, onDelete, onReparse } = this.props;
    return (
      <Box column w100>
        {!!resumes.length &&
          resumes.map((resume, index) => {
            return (
              <Box row w100
                key={joinKeyName([
                  'resume_links',
                  resume.url,
                  index
                ])}
                className='py-05'
              >
                <Box title='Download resume file'>
                  <IconButton
                    onClick={ev =>
                      fetchCandidateResume({
                        download: true,
                        url: resume.url,
                        source: 'ResumeLinks__DownloadFile_IconButton'
                      }).catch(error => {
                        onError(error);
                      })
                    }
                    icon='file_download'
                  />
                </Box>
                <Box
                  acl={Core.isAdmin()}
                  title={resume.parseError || 'Re-parse resume'}
                >
                  <IconButton
                    onClick={ev => {
                      onReparse({
                        url: resume.url,
                        filename: decodeURIComponent(
                          Str(resume.url).split("/").pop()
                        )
                      });
                    }}
                    disabled={resume.parseError}
                    icon='redo'
                  />
                </Box>
                <Box title='Remove resume'>
                  <IconButton
                    onClick={event => onDelete(event, resume, index)}
                    icon='close'
                  />
                </Box>
                <Button small flat
                  className='truncate flex-align-left-center c-purple-all pointer'
                  onClick={(event) => fetchCandidateResume({
                    title: getPersonName(
                      getControllerCandidateEdit().state
                    ),
                    url: resume.url,
                    open: true,
                    source: 'ResumeLinks__OpenCandidateResume_Button',
                  }).catch(error => {
                    onError(error);
                  })}
                >
                  {decodeURIComponent(
                    String(resume.url)
                      .split("/")
                      .pop()
                  )}
                </Button>
              </Box>
            );
          })}
      </Box>
    )
  }
}